/**
 * Utilities for reinitializing third-party scripts after Turbo navigation.
 */
export default class ThirdParty {
  /**
   * Register a callback to run after Turbo navigation (skips initial page load).
   * The flag is per registration: a shared one would let the first callback
   * consume it, so every later callback would fire on the initial load too.
   * @param {Function} callback - Function to call on Turbo navigation
   */
  static onTurboNavigation(callback) {
    let initialPageLoad = true;

    document.addEventListener('turbo:load', () => {
      if (initialPageLoad) {
        initialPageLoad = false;
        return;
      }
      callback();
    });
  }

  /**
   * Reload a regular script by injecting a new script tag.
   * @param {string} url - Script URL (cache-busting timestamp added automatically)
   */
  static reloadScript(url) {
    const script = document.createElement('script');
    script.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
    document.head.appendChild(script);
  }

  /**
   * Reload an ES module by dynamically importing it.
   * @param {string} url - Module URL (cache-busting timestamp added automatically)
   * @returns {Promise} - Import promise
   */
  static reloadModule(url) {
    const cleanUrl = url.split('?')[0];
    return import(cleanUrl + '?t=' + Date.now());
  }
}
